import { INSTALL_SUCCESS_ACTION_CONTENT } from '@atlassian/emcee/app-install';

export const GRAPHQL_GATEWAY_PATH = '/gateway/api/graphql';

export const DEFAULT_APP_CONFIGURATION_URL = '/plugins/servlet/upm';

// Marketplace app actions that require prompting the user in a post-installation modal
export const APP_POST_INSTALL_CONFIGURE_ACTIONS = [
	INSTALL_SUCCESS_ACTION_CONTENT.getStarted,
	INSTALL_SUCCESS_ACTION_CONTENT.configure,
];
